import Localization from '~/client/src/shared/localization/LocalizationManager'
import User from '~/client/src/shared/models/User'
import UserProject from '~/client/src/shared/models/UserProject'
import CompaniesStore from '~/client/src/shared/stores/domain/Companies.store'
import ProjectMembersStore from '~/client/src/shared/stores/domain/ProjectMembers.store'
import ProjectRolesStore from '~/client/src/shared/stores/domain/ProjectRoles.store'
import UserProjectsStore from '~/client/src/shared/stores/domain/UserProjects.store'

import { Chat, Contact } from '../core/protocol/types'

export class WebContactDirectory {
  public constructor(
    private readonly projectMembersStore: ProjectMembersStore,
    private readonly userProjectsStore: UserProjectsStore,
    private readonly companiesStore: CompaniesStore,
    private readonly projectRolesStore: ProjectRolesStore,
  ) {}

  public getProjectMember(userId: string): User | undefined {
    return this.projectMembersStore.getById(userId) || undefined
  }

  public listMembers(excludeUserId: string): User[] {
    return this.projectMembersStore.list.filter(
      member => member.id !== excludeUserId,
    )
  }

  public toContact(userId: string): Contact | undefined {
    const member = this.getProjectMember(userId)
    if (!member) {
      return undefined
    }
    return {
      id: member.id,
      fullName: member.fullName,
      avatarUrl: member.avatarUrl,
      initials: member.initials,
    }
  }

  public directSubtitle(recipientId: string | undefined): string {
    const recipient = recipientId && this.getProjectMember(recipientId)
    if (!recipient) {
      return ''
    }

    const companyName = UserProject.getCompanyName(
      recipient,
      this.userProjectsStore,
      this.companiesStore,
    )
    const roles = UserProject.getAllRolesAsString(
      recipient,
      this.userProjectsStore,
      this.projectRolesStore,
    )

    return [companyName, roles].filter(part => !!part).join(', ')
  }

  public groupSubtitle(chat: Chat): string {
    const memberPortion = Localization.translator.xMembers(
      chat.memberIds.length,
    )

    const companyNames = [
      ...new Set(
        chat.memberIds
          .map(memberId => {
            const member = this.getProjectMember(memberId)
            return member
              ? UserProject.getCompanyName(
                  member,
                  this.userProjectsStore,
                  this.companiesStore,
                  '',
                )
              : ''
          })
          .filter(name => !!name),
      ),
    ]

    if (!companyNames.length) {
      return memberPortion
    }
    if (companyNames.length === 1) {
      return `${memberPortion}, (${companyNames[0]})`
    }
    return `${memberPortion}, (${Localization.translator.xCompanies(
      companyNames.length,
    )})`
  }
}
